import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { CategoryDistribution } from '../../../models/analytics.model';

@Component({
    selector: 'app-analytics-category-chart',
    templateUrl: './analytics-category-chart.component.html',
    styleUrls: ['./analytics-category-chart.component.scss'],
})
export class AnalyticsCategoryChartComponent implements OnChanges {
    @Input() data: CategoryDistribution[] = [];
    @Input() colorMap: Record<string, string> = {};

    chartData: ChartConfiguration<'doughnut'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'doughnut'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    boxWidth: 12,
                    padding: 12,
                    font: { family: "'Montserrat', sans-serif", size: 12 },
                },
            },
        },
        cutout: '60%',
    };

    private fallbackPalette = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#f97316', '#14b8a6', '#6366f1'];

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;

        this.chartData = {
            labels: this.data.map((c) => c.name),
            datasets: [
                {
                    data: this.data.map((c) => c.count),
                    backgroundColor: this.data.map((c, i) => this.colorMap[c.categoryId] || this.fallbackPalette[i % this.fallbackPalette.length]),
                    borderWidth: 2,
                    borderColor: '#ffffff',
                },
            ],
        };
    }
}
